import React from 'react';
import '../styles/WaitlistProgressBanner.css';

const WaitlistProgressBanner = ({ isVisible, step = 1 }) => {
  if (!isVisible) return null;

  const getStepText = (currentStep) => {
    switch (currentStep) {
      case 1:
        return "Step 1 of 3";
      case 2:
        return "Step 2 of 3";
      case 3:
        return "Step 3 of 3";
      default:
        return "Step 1 of 3";
    }
  };

  const getProgressWidth = (currentStep) => {
    switch (currentStep) {
      case 1:
        return "33%";
      case 2:
        return "66%";
      case 3:
        return "100%";
      default:
        return "33%";
    }
  };

  return (
    <div className="waitlist-progress-banner">
      <div className="progress-banner-content">
        <div className="progress-info">
          <div className="progress-icon">
            🎁
          </div>
          <div className="progress-text">
            <span className="progress-step">{getStepText(step)}</span>
            <span className="progress-message">— Secure your FREE 1-year Yesod Premium! Don't miss out.</span>
          </div>
        </div>
        <div className="progress-bar-container">
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: getProgressWidth(step) }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaitlistProgressBanner;
